/**
 * 个人产品管理路由保护组件
 * 只有系统管理员和个人产品管理员可以访问
 */
import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { hasPrivateFundPermission } from '../utils/privateFundAuth';

const PrivateFundRoute = ({ children }) => {
  const location = useLocation();
  const [hasPermission, setHasPermission] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const permission = await hasPrivateFundPermission();
        console.log('PrivateFundRoute: 权限检查结果', permission);
        setHasPermission(permission);
      } catch (error) {
        console.error('PrivateFundRoute: 权限检查失败', error);
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermission();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!hasPermission) {
    // 没有权限，显示错误提示并重定向到首页
    setTimeout(() => {
      const userStr = localStorage.getItem('user');
      let userInfo = '';
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          userInfo = `（当前用户: ${user.name || user.email}）`;
        } catch (e) {
          // ignore
        }
      }
      alert(`您没有访问个人产品管理系统的权限，请联系管理员分配个人产品管理员角色${userInfo}`);
    }, 100);
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateFundRoute;
